var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhymetasoftlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5704 28.9456C27.0391 28.9456 30.6313 32.6164 30.6097 37.1508C30.588 41.5773 26.9633 45.0105 22.3216 44.9998C17.9612 44.9998 14.5962 41.4478 14.5637 36.8701C14.5204 32.5408 18.4697 28.7513 22.5704 28.9456Z",
    fill: "#ED1E7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2997 16.1189C18.2422 16.1405 14.7366 12.7288 14.5743 8.1944C14.412 3.8003 17.9609 0 22.4295 0C26.8333 0 30.3064 3.24969 30.5878 7.68697C30.8366 11.6708 27.7746 16.0865 22.2997 16.1189Z",
    fill: "#4EB7DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92075 14.3274C12.4327 14.2735 16.0465 17.7931 16.079 22.3059C16.1006 26.3329 12.9304 30.3384 7.97485 30.3492C3.5495 30.36 0.0654751 26.8404 0.000555515 22.2627C-0.0535441 18.063 3.85246 14.0791 7.92075 14.3274Z",
    fill: "#F0422B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8742 14.3265C41.451 14.2941 44.9783 17.8677 44.9999 22.4345C45.0108 26.5263 41.6458 30.4238 36.701 30.3698C32.4055 30.3158 29.0081 26.753 28.9323 22.2186C28.8674 17.8677 32.9465 14.0781 36.8742 14.3373V14.3265Z",
    fill: "#87C635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhymetasoftlogo);
export default __webpack_public_path__ + "static/media/whymetasoftlogo.49c2e7112b0681bb76926c83a9f2fba3.svg";
export { ForwardRef as ReactComponent };